import React, { Component } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';

import { Loading } from './Loading';
import { PerspectaModal, ModalHeader, ModalBody, ModalFooter } from './Modal';
import { Stages, Stage } from './Stages';

export const StagedModalStages = {
    EDIT: 0,
    SAVING: 1,
    SUCCESS: 2,
    ERROR: 3
}
/**
 * Modal for showing an Edit, Loading, Success/Error workflow
 */
export class StagedModal extends Component {

    static propTypes = {
        // Is modal opened/closed?
        isOpen: PropTypes.bool,
        // Title of modal
        title: PropTypes.string,
        // Title of modal on success stage
        successStageTitle: PropTypes.string,
        // Title of modal on error stage
        errorStageTitle: PropTypes.string,
        // Text for cancel button
        cancelBtnText: PropTypes.string,
        // Text for affirmation button
        affirmationBtnText: PropTypes.string,
        // Callback for when affirmation button is clicked
        onAffirmation: PropTypes.func,
        // Render prop for rendering the edit stage
        renderEditStage: PropTypes.func,
        // Render prop for rendering success stage
        renderSuccessStage: PropTypes.func,
        // Render prop for rendering loading stage
        renderSavingText: PropTypes.string,
        // Callback for when modal is closed
        onClose: PropTypes.func
    }

    static defaultProps = {
        cancelBtnText: 'Cancel',
        affirmationBtnText: 'Yes',
        affirmationBtnClass: '',
        errorStageTitle: 'Error',
        successStageBtnText: 'Ok, Thanks!',
        renderSavingText: 'Please Wait...'
    }

    constructor(props) {
        super(props);

        this.state = {
            activeStage: StagedModalStages.EDIT,
            isOpen: this.props.isOpen
        };
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.isOpen !== prevProps.isOpen) {
            this.setState({
                isOpen: this.props.isOpen
            });
        }
    }

    render() {
        let title = this.props.title;
        if (this.state.activeStage === StagedModalStages.SUCCESS) {
            title = this.props.successStageTitle;
        } else if (this.state.activeStage === StagedModalStages.ERROR) {
            title = this.props.errorStageTitle;
        }
        return (
            <PerspectaModal
                environment={this.props.environment}
                isOpen={this.state.isOpen}
                title={title}
                size={this.props.size}
                onClose={this.handleCloseModal}>
                {this.renderModal()}
            </PerspectaModal>
        );
    }

    renderModal() {
        return (
            <Stages activeStage={this.state.activeStage}>
                <Stage stageIndex={StagedModalStages.EDIT}>
                    <ModalBody>
                        {this.renderEditStageContent()}

                        <ModalFooter
                            handleNeg={this.handleCloseModal}
                            textNeg={this.props.cancelBtnText}
                            handlePos={this.handleAffirmationClick}
                            textPos={this.props.affirmationBtnText}
                            classNamePos={this.props.affirmationBtnClass}
                        />
                    </ModalBody>
                </Stage>

                <Stage stageIndex={StagedModalStages.SAVING}>
                    <Loading isLoading={true} />
                    <div className="h4 text-center py-6">{this.props.renderSavingText}</div>
                </Stage>

                <Stage stageIndex={StagedModalStages.SUCCESS}>
                    <ModalBody>
                        {this.renderSuccessStageContent()}

                        <div className="modal-footer modal-footer--lg modal-footer--centered">
                            <a className="btn-size--lg btn-solid--primary"
                                onClick={this.handleCloseModal}>{this.props.successStageBtnText}</a>
                        </div>
                    </ModalBody>
                </Stage>

                <Stage stageIndex={StagedModalStages.ERROR}>
                    <div className="text-center padding-top-lg padding-bottom-lg">
                        <h4>{this.state.errorMessage}</h4>
                    </div>
                </Stage>

            </Stages>
        );
    }

    renderEditStageContent() {
        if (this.props.renderEditStage) {
            return this.props.renderEditStage();
        } else {
            return (
                <div className="padding-lg" 
                    dangerouslySetInnerHTML={{__html: this.props.editStageContent}}>
                </div>
            );
        }
    }

    renderSuccessStageContent() {
        if (this.props.renderSuccessStage) {
            return this.props.renderSuccessStage();
        } else {
            return (
                <div className="text-center padding-top-lg padding-bottom-lg" 
                    dangerouslySetInnerHTML={{__html: this.props.successStageContent}}>   
                </div>
            )
        }
    }

    handleCloseModal = (e) => {
        let closingOnStage = this.state.activeStage;

        this.setState({
            isOpen: false
        }, () => {
            if (this.props.onClose) {
                // Delay close callback for animation to finish
                setTimeout(() => {
                    this.setState({
                        activeStage: StagedModalStages.EDIT
                    });
                    this.props.onClose(closingOnStage);
                }, 200);
            }
        });
    }

    handleAffirmationClick = (e) => {
        this.setState({
            activeStage: StagedModalStages.SAVING
        });

        if (this.props.onAffirmation) {
            //console.log('triggering callback',this.props.onAffirmation);
            this.props.onAffirmation(this.handleSuccessfulAffirmation, this.handleErrorAffirmation);
        }
    }

    handleSuccessfulAffirmation = () => {
        this.setState({
            activeStage: StagedModalStages.SUCCESS
        });
    }

    handleErrorAffirmation = (result) => {
        this.setState({
            activeStage: StagedModalStages.ERROR,
            errorMessage: result.Message
        });
    }
}